import { render, staticRenderFns } from "./zhiri.vue?vue&type=template&id=909afe48&scoped=true"
import script from "./zhiri.vue?vue&type=script&lang=js"
export * from "./zhiri.vue?vue&type=script&lang=js"
import style0 from "./zhiri.vue?vue&type=style&index=0&id=909afe48&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909afe48",
  null
  
)

export default component.exports